// src/ConfigProvider/index.tsx
import { ConfigProvider } from "antd";
import React from "react";
import { ThemeContextProvider } from "./theme";
var LuxConfigProvider = (props) => {
  const { children, luxTheme, ...restProps } = props;
  return /* @__PURE__ */ React.createElement(ConfigProvider, { ...restProps }, /* @__PURE__ */ React.createElement(ThemeContextProvider, { theme: luxTheme }, children));
};
var ConfigProvider_default = LuxConfigProvider;
export {
  ConfigProvider_default as default
};
